import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {LineupsMemberStatsApiModel} from "./lineups-member.stats.api-model";

export class LineupsMemberStatsDomainModel extends BaseDomainModel {
  apiModel: LineupsMemberStatsApiModel;

  get type(): Number {
    return this.apiModel.type;
  }

  get value(): String {
    return this.apiModel.value;
  }

  get isTop(): Boolean {
    return this.apiModel.isTop;
  }

  get categoryId(): Number {
    return this.apiModel.categoryId;
  }

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get order(): Number {
    return this.apiModel.order;
  }

  get imageId(): Number {
    return this.apiModel.imageId;
  }
}